@for (item of category; track item; let indexOfFilterCategory = $index) {
  <div class="filter-category">
    @if (!item.name.includes('_')) {
      <div>
        <button [disabled]="item.isDisabled" mat-flat-button class="filter-button" id="{{ item.name }}" (click)="openPopup(item)" [class.active]="isCategoryActive(item)">
          {{ item.name }}
        </button>

        @if (isCheckBox(item) && item.active) {
          <app-filters-checkbox [filterTitle]="item.name" [filterOptions]="item.data" (applyFilter)="apply($event, item)" (closePopUp)="item.active = false"> </app-filters-checkbox>
        }

        @if (isDateSelection(item) && item.active) {
          <app-filters-dates [filterTitle]="item.name" [filterOptions]="item.dates" [rightJustify]="indexOfFilterCategory >= 2" (applyFilter)="applyDateFilter($event, item)" (closePopUp)="item.active = false"> </app-filters-dates>
        }
      </div>
    }
  </div>
}
